import useFeatureFlagByNameKey from '@/shared/hooks/useFeatureFlagByNameKey/useFeatureFlagByNameKey';

const useChangelogRecordFeatureFlag = () => {
  const { valueFeatureFlag, loading } = useFeatureFlagByNameKey(
    'COURSE_CHANGELOG_RECORD',
  );

  return {
    isChangelogRecordActive: valueFeatureFlag,
    isLoadingChangelogRecord: loading,
  };
};

export default useChangelogRecordFeatureFlag;
